import { useMemo } from 'react';

import { useGetRestrictionsPermissions } from '../redux/api/users/usersApi';

export const useRestrictions = () => {
  const {
    data: permissions,
    isLoading,
    isFetching,
    isError,
    isUninitialized,
  } = useGetRestrictionsPermissions();

  const isPending =
    isUninitialized || isLoading || (isFetching && !permissions);

  const restrictionsPermissionsReady = !isPending && !isError && !!permissions;

  const canCreateExercise = Boolean(
    restrictionsPermissionsReady && permissions?.canCreateExercise,
  );
  const canCreateProgramCollection = Boolean(
    restrictionsPermissionsReady && permissions?.canCreateProgramCollection,
  );
  const canCreateProgramItem = Boolean(
    restrictionsPermissionsReady && permissions?.canCreateProgramItem,
  );
  const canStartTraining = Boolean(
    restrictionsPermissionsReady && permissions?.canStartTraining,
  );
  const canGenerateTraining = Boolean(
    restrictionsPermissionsReady && permissions?.canGenerateTraining,
  );

  const isShowAddButton = useMemo(
    () => ({
      exercises: restrictionsPermissionsReady,
      programItem: restrictionsPermissionsReady,
      programCollection: restrictionsPermissionsReady,
      training: restrictionsPermissionsReady,
    }),
    [restrictionsPermissionsReady],
  );

  const isShowPlanDialogOnClick = useMemo(() => {
    if (!restrictionsPermissionsReady || !permissions) {
      return {
        exercises: false,
        programItem: false,
        programCollection: false,
        startTraining: false,
        generateTraining: false,
      };
    }
    return {
      exercises: !permissions.canCreateExercise,
      programItem: !permissions.canCreateProgramItem,
      programCollection: !permissions.canCreateProgramCollection,
      startTraining: !permissions.canStartTraining,
      generateTraining: !permissions.canGenerateTraining,
    };
  }, [restrictionsPermissionsReady, permissions]);

  return {
    restrictionsPermissionsReady,
    canCreateExercise,
    canCreateProgramCollection,
    canCreateProgramItem,
    canStartTraining,
    canGenerateTraining,
    isShowAddButton,
    isShowPlanDialogOnClick,
  };
};
